import React, { useState, useEffect, useContext } from 'react';
import { Table, Button, Select, Space, Spin } from 'antd';
import icon_vector from 'images/icon_vector.svg';
import icon_sampling from 'images/icon_sampling.svg';
import icon_arrow_down from 'images/icon_arrow_down.svg';
import icon_arrow_up from 'images/icon_arrow_up.svg';

import { AppContext } from 'context/AppContext';
import { useNavigate } from 'react-router-dom';

import ProjectSampleModal from '../newModal/ProjectSampleModal';

import { getData } from 'services/home';
import ProjectDropdown from './components/ProjectDropdown';
import FileDropdown from './components/FileDropdown';
import FileDropdownToUnfinishedData from './components/FileDropdownToUnfinishedData';
import Loader from 'components/Loader';
import icon_processing from 'images/icon_processing.svg';
import icon_processing_blue from 'images/icon_processing_blue.svg';
import ProjectDropdownToUnfinishedData from './components/ProjectDropdownToUnfinishedData';
const { Option } = Select;

const ClientTable = (props) => {
    let navigate = useNavigate();
    const appContext = useContext(AppContext);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [sampleUploadId, setSampleUploadId] = useState();
    const [dataTable, setDataTable] = useState();
    const [selectRow, setSelectRow] = useState([]);
    const [loadingDataFromServer, setLoadingDataFromServer] = useState(true);
    const [rerenderTableProject, setRerenderTableProject] = useState(true);
    const [openFirstRow, setOpenFirstRow] = useState(false);
    const [firstRowId, setFirstRowId] = useState([]);

    const getWindowSize = () => {
        const { innerWidth, innerHeight } = window;
        return { innerWidth, innerHeight };
    };
    const [windowSize, setWindowSize] = useState(getWindowSize());

    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    const handleTableRender = () => {
        setRerenderTableProject(!rerenderTableProject);
    };

    const showModal = (uploadId) => {
        setIsModalVisible(true);
        setSampleUploadId(uploadId);
    };

    useEffect(() => {
        setLoadingDataFromServer(true);
        getData()
            .then((res) => {
                setDataTable(res.data.results);
                if (res.status === 200) {
                    setLoadingDataFromServer(false);
                }

                if (res.data.results[0].id !== undefined) {
                    setFirstRowId(res.data.results[0].id);
                }

                setTimeout('', 500);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [rerenderTableProject, props.preloadedDatasetFinish]);

    const expandedOnClick = (keyId) => {
        let newSelectRow = [...selectRow];
        if (newSelectRow.includes(keyId)) {
            newSelectRow = newSelectRow.filter((el) => el !== keyId);
        } else {
            newSelectRow.push(keyId);
        }
        setSelectRow(newSelectRow);
    };

    const handleSetGlobalProject = (projectId) => {
        let currentProject = localStorage.setItem('activeProject', projectId);
    };

    const expandedRowRender = (record) => {
        const columns = [
            {
                title: 'Project Name',
                dataIndex: 'name',
                width: '36%',
                render: (t, r, i) => {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {r.status == 'toprocess' ? (
                                // <div style={{ marginLeft: '8px' }}>
                                //     <img
                                //         className="processing-spin"
                                //         src={icon_processing_blue}
                                //     />
                                // </div>
                                <>
                                    <img
                                        src={icon_sampling}
                                        className="icon-sampling-svg"
                                        style={{ opacity: 0.5 }}
                                    />{' '}
                                    <div
                                        className="font-roboto-blue-15"
                                        style={{ marginLeft: 20 }}
                                    >
                                        <div
                                            className="a-link-hover"
                                            style={{ opacity: 0.5 }}
                                        >
                                            {r.name}
                                        </div>
                                    </div>{' '}
                                </>
                            ) : (
                                <>
                                    <img
                                        src={icon_sampling}
                                        className="icon-sampling-svg"
                                    />{' '}
                                    <div
                                        className="font-roboto-blue-15"
                                        style={{ marginLeft: 20 }}
                                    >
                                        <div
                                            className="a-link-hover"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                                handleSetGlobalProject(r.id);

                                                localStorage.setItem(
                                                    'activeProject',
                                                    r.id
                                                );
                                                appContext.setCurrentLocation([
                                                    '2'
                                                ]);
                                                navigate(`/project/${r.id}`);
                                            }}
                                        >
                                            {r.name}
                                        </div>
                                    </div>{' '}
                                </>
                            )}
                        </div>
                    );
                }
            },

            {
                title: 'Project Rows',
                dataIndex: 'sample_size',
                width: '15%',
                render: (t, r, i) => {
                    return (
                        <>
                            {r.status == 'toprocess' ? (
                                <div className="processing-button">
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            width: '100%'
                                        }}
                                    >
                                        <div>PROCESSING</div>
                                        <div style={{ marginLeft: '8px' }}>
                                            <img
                                                className="processing-spin"
                                                src={icon_processing}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div>{`Rows: ${r.row_count}`}</div>
                            )}
                        </>
                    );
                }
            },
            {
                title: 'Project Columns',
                dataIndex: 'sample_size',
                width: '15%',
                render: (t, r, i) => {
                    return (
                        <>
                            {r.status == 'toprocess' ? null : (
                                <div>{`Columns: ${r.col_count}`}</div>
                            )}
                        </>
                    );
                }
            },
            {
                title: 'Project LastOpened',
                dataIndex: 'created_at',
                render: (t, r, i) => {
                    let created = new Date(
                        Date.parse(r.created_at)
                    ).toLocaleDateString();
                    return (
                        <>
                            <div
                                id={r.id}
                                style={
                                    r.status == 'toprocess'
                                        ? { opacity: 0.5 }
                                        : null
                                }
                            >
                                {created}
                            </div>
                        </>
                    );
                }
            },
            {
                title: '',
                dataIndex: '',
                render: (t, r, i) => {
                    return (
                        <>
                            {r.status == 'toprocess' ? (
                                <ProjectDropdownToUnfinishedData
                                    row={r}
                                    dataTable={dataTable}
                                    setDataTable={setDataTable}
                                    handleTableRender={handleTableRender}
                                />
                            ) : (
                                <ProjectDropdown
                                    location="home"
                                    row={r}
                                    dataTable={dataTable}
                                    setDataTable={setDataTable}
                                    handleTableRender={handleTableRender}
                                    hideExportAnalysis={true}
                                />
                            )}
                        </>
                    );
                }
            }
        ];

        return (
            <Table
                className="component-expand-table-homeview"
                columns={columns}
                rowClassName={(record, index) => {
                    if (record.status == 'toprocess') {
                        return 'row-toprocess';
                    } else {
                        return null;
                    }
                }}
                rowKey="id"
                dataSource={record.projects}
                pagination={false}
                showHeader={false}
                defaultExpandAllRows={true}
            />
        );
    };

    const projectsCorrectName = (l) => {
        return l > 1 || l == 0 ? l + ' Projects' : l + ' Project';
    };

    const columns = [
        {
            title: 'Dataset',
            dataIndex: 'name',
            width: '36%',
            render: (t, r, i) => {
                return (
                    <>
                        <div
                            className="font-roboto-black-18"
                            style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <img
                                src={icon_vector}
                                className="icon-vector-svg"
                            />
                            {r.status == 'toprocess' ||
                            r.status == 'econometrica_preview' ||
                            r.status == 'preview' ? (
                                <div
                                    className="font-roboto-blue-18 crp"
                                    style={{ marginLeft: 20, cursor: 'auto' }}
                                >
                                    {r.name}
                                </div>
                            ) : (
                                <div
                                    className="font-roboto-blue-18 crp"
                                    style={{ marginLeft: 20 }}
                                    onClick={() => {
                                        expandedOnClick(r.id, i);
                                        setOpenFirstRow(false);
                                    }}
                                >
                                    {r.name}
                                </div>
                            )}
                        </div>
                        {r.status == 'toprocess' ||
                        r.status == 'econometrica_preview' ||
                        r.status == 'preview' ? null : (
                            <div
                                onClick={() => {
                                    expandedOnClick(r.id, i);
                                    setOpenFirstRow(false);
                                }}
                                style={{
                                    display: 'flex',
                                    margin: '15px 0 0 35px'
                                }}
                            >
                                {selectRow.includes(r.id) ? (
                                    <img src={icon_arrow_up} />
                                ) : (
                                    <img src={icon_arrow_down} />
                                )}
                                <div
                                    style={{
                                        marginLeft: 10,
                                        cursor: 'pointer'
                                    }}
                                >
                                    {projectsCorrectName(r.projects.length)}
                                </div>
                            </div>
                        )}
                    </>
                );
            }
        },
        {
            title: 'Original Data File',
            dataIndex: 'file_name',
            hidden: windowSize.innerWidth > 1000 ? false : true,
            render: (t, r, i) => {
                return (
                    <>
                        <div className="font-roboto-grey-18">{r.file_name}</div>
                    </>
                );
            }
        },
        {
            title: 'Uploaded',
            className: 'updated-column-width-small',
            dataIndex: 'created_at',
            render: (t, r, i) => {
                let created = new Date(
                    Date.parse(r.created_at)
                ).toLocaleDateString();
                let newProjectBtn = (
                    <Button
                        className="blue-button"
                        type="primary"
                        onClick={() => {
                            showModal(r.id);
                        }}
                    >
                        {}
                        NEW PROJECT
                    </Button>
                );

                let finalizeBtn = (
                    <div
                        className="finalize-button"
                        // type="primary"
                        onClick={() => {
                            navigate(`/setheaderrow/${r.id}`);
                        }}
                    >
                        {}
                        FINALIZE
                    </div>
                );

                let processingBtn = (
                    <div className="processing-button">
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                width: '100%'
                            }}
                        >
                            <div>PROCESSING</div>
                            <div style={{ marginLeft: '8px' }}>
                                <img
                                    className="processing-spin"
                                    src={icon_processing}
                                />
                            </div>
                        </div>
                    </div>
                );

                return (
                    <>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <div style={{ width: 80 }}>
                                {r.status == 'toprocess' ? null : created}{' '}
                            </div>
                            {r.status == 'done' ? newProjectBtn : null}
                            {r.status == 'preview' ||
                            r.status == 'econometrica_preview'
                                ? finalizeBtn
                                : null}
                            {r.status == 'toprocess' ? processingBtn : null}
                            {/* <Button
                                className="blue-button"
                                type="primary"
                                onClick={() => {
                                    showModal(r.id);
                                }}
                            >
                                {}
                                NEW PROJECT
                            </Button> */}
                        </div>
                    </>
                );
            }
        },
        {
            title: '',
            dataIndex: '',
            className: 'dots-icon-delete-project-width',
            render: (t, r, i) => {
                return (
                    <>
                        {r.status == 'toprocess' ||
                        r.status == 'econometrica_preview' ||
                        r.status == 'preview' ? (
                            <FileDropdownToUnfinishedData
                                row={r}
                                dataTable={dataTable}
                                setDataTable={setDataTable}
                                handleTableRender={handleTableRender}
                            />
                        ) : (
                            <FileDropdown
                                row={r}
                                dataTable={dataTable}
                                setDataTable={setDataTable}
                                handleTableRender={handleTableRender}
                            />
                        )}
                    </>
                );
            }
        }
    ].filter((item) => !item.hidden);

    return (
        <>
            {loadingDataFromServer ? (
                <div
                    style={{
                        height: '50vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <Space>
                        <Loader />
                    </Space>
                </div>
            ) : (
                <div>
                    <Table
                        className="components-table-homeview"
                        rowClassName={(record, index) => {
                            if (record.status == 'toprocess') {
                                return 'row-toprocess';
                            } else {
                                return null;
                            }
                        }}
                        columns={columns}
                        rowKey="id"
                        expandable={{
                            expandedRowRender,
                            expandIcon: ({ expanded, onExpand, record }) =>
                                expanded ? (
                                    <img
                                        src={icon_arrow_up}
                                        onClick={(e) => onExpand(record, e)}
                                    />
                                ) : (
                                    <img
                                        src={icon_arrow_down}
                                        onClick={(e) => onExpand(record, e)}
                                    />
                                )
                        }}
                        dataSource={dataTable}
                        pagination={false}
                        style={{ marginTop: 100 }}
                        showExpandColumn={false}
                        expandedRowKeys={selectRow}
                        // expandedRowKeys={
                        //     openFirstRow ? [firstRowId] : selectRow
                        // }
                    />
                </div>
            )}

            <ProjectSampleModal
                visible={isModalVisible}
                setIsModalVisible={setIsModalVisible}
                sampleUploadId={sampleUploadId}
                handleTableRender={handleTableRender}
                openFirstRow={openFirstRow}
                setOpenFirstRow={setOpenFirstRow}
                setSelectRow={setSelectRow}
            />
        </>
    );
};

export default ClientTable;
